/* cc-cart2.js - "Cart 2.0" (version 7) variant of the UpCart drawer, cart test 6 (Oct 2026).
   Layers on top of cc-clean-cart.js (the simple cart) inside UpCart's shadow root (#upCart).
   Active only when: ?cartoffer=1 (kept for the browser session, ?cartoffer=0 turns it off), or an UpCart
   A/B test is running and this browser is in the Cart 2.0 arm (CART2_VARIANT_ID, set once the test starts).
   Adds: tracked delivery bar, group labels, "60 sheets", switch-to-monthly box on a one-time 1 Pack,
   "Saving $X a month" chip after a switch, "Add to your order" product row, Judy's quote, trust line.
   Writes to the cart only on a shopper tap (switch, add). Reads /cart.js once per UpCart render, never polls.
   Every line it adds or switches carries _hs_cartoffer = addon | addon_onetime | switch.
   Roll back: remove this file's render line from layout/theme.liquid. */
(function () {
  'use strict';
  var CART2_VARIANT_ID = 'e7c52e35-2359-4684-b8d4-dc7b19f3636f'; // UpCart cart id of the Cart 2.0 arm; set after Jack starts the test and we read each arm's id
  var LAUNDRY = 'laundry-sheets';
  var DONATE = '/products/donate-a-load-of-laundry';
  var DONATE_SKU = 'HS-LDS-DNT1U';
  var PLAN = { laundry: 8589246751, dryer: 8587116831, dish: 8588689695 }; // Every 30 Days
  var V = { dryerOB: 51356902162719, dryerFF: 51762343248159, dish: 49226390765855, wool: 52400516497695, towels: 52520060191007 };
  var HANDLES = { laundry: 'laundry-sheets', dryer: 'dryer-sheets', dish: 'dishwasher-sheets', wool: 'wool-dryer-balls', towels: 'reusable-paper-towels' };
  var QUOTE = 'They clean well, including a wine stain I had on one of my shirts.';

  function override() {
    try {
      var q = new URLSearchParams(location.search).get('cartoffer');
      if (q === '1' || q === '0') sessionStorage.setItem('cc-cart2', q);
      return sessionStorage.getItem('cc-cart2');
    } catch (e) { return null; }
  }

  function isOn() {
    var o = override();
    if (o === '1') return true;
    if (o === '0') return false;
    if (!CART2_VARIANT_ID) return false;
    try {
      var s = window.upcartSettings || {};
      var ids = (s.upcartSettings && s.upcartSettings.activeCartIds) || [];
      var cur = s.upcartEditorSettings && s.upcartEditorSettings.cartId;
      return Array.isArray(ids) && ids.length >= 2 && cur === CART2_VARIANT_ID;
    } catch (e) { return false; }
  }

  var TRUCK = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><g fill="none" stroke="#097680" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.5h11v9.5h-11zM13.5 9.5h4l3.5 3.5v3h-7.5"/><circle cx="6.5" cy="17.5" r="1.8" fill="#fff"/><circle cx="17" cy="17.5" r="1.8" fill="#fff"/></g></svg>';
  var TICK = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#21C4D5"/><path d="M7.5 12.3l3 3 6-6.3" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var CSS = [
    /* top: header, delivery bar, donation strip (cc-clean-cart), in that order */
    '[class*="CartPreview__card"]>div:first-child{display:flex;flex-direction:column}',
    '.cc2-ship{order:1;padding:12px 20px 13px;border-bottom:1px solid #ECE9E4;background:#fff}',
    '#CartPopup .cc-strip{order:2;justify-content:center;gap:7px;padding:9px 10px;font:400 12px/1.35 "Source Sans 3","Source Sans Pro",sans-serif;letter-spacing:-.15px;white-space:nowrap;border-bottom-color:#DCEFF2}',
    '#CartPopup .cc-strip svg{width:16px;height:16px}',
    '.cc2-ship-t{display:flex;align-items:center;gap:9px;font:400 13px/1.35 "Source Sans 3","Source Sans Pro",sans-serif;color:#1F2024}',
    '.cc2-ship-t svg{flex:none}',
    '.cc2-ship-t span{text-wrap:balance}',
    '.cc2-track{position:relative;height:4px;background:#E6E8EA;border-radius:2px;margin-top:9px}',
    '.cc2-track i{position:absolute;left:0;top:0;bottom:0;background:#21C4D5;border-radius:2px}',
    /* body: lines grouped, product row, quote pinned to the bottom when there is room */
    '.upcart-cart-body{display:flex;flex-direction:column}',
    '.upcart-cart-body>*{flex-shrink:0}',
    'ul.upcart-internal-cart-items{display:flex;flex-direction:column;padding:0 20px!important;margin:0!important}',
    'li.upcart-internal-cart-item{padding:0!important;border:0!important}',
    'li.upcart-internal-cart-item.cc2-sep{border-top:1px solid #ECE9E4!important;padding-top:18px!important}',
    '.cc2-grp{display:flex;align-items:center;gap:10px;font:400 12.5px/1 "Source Sans 3","Source Sans Pro",sans-serif;color:#6B6E72;margin:20px 0 16px;letter-spacing:.2px}',
    '.cc2-grp:after{content:"";flex:1;height:1px;background:#ECE9E4}',
    '.upcart-internal-component-product-tile{padding:0 0 18px!important;margin:0!important}',
    '.upcart-internal-component-product-tile__content{gap:14px!important;align-items:flex-start!important}',
    '.upcart-internal-component-product-tile__image-wrapper,.upcart-internal-component-product-tile__image{width:72px!important;height:72px!important;min-width:72px!important;border-radius:4px;background:#F6F4F0;object-fit:contain}',
    '.upcart-internal-component-product-tile__info{display:grid!important;grid-template-columns:minmax(0,1fr) auto;align-items:center;min-width:0;flex:1}',
    '.upcart-internal-component-product-tile__info>*{grid-column:1/-1;min-width:0}',
    '.upcart-internal-component-product-tile__product-title,.upcart-internal-component-product-tile__product-title a{font:600 14.5px/1.25 Montserrat,sans-serif!important;letter-spacing:.2px;color:#1F2024!important}',
    '.upcart-internal-component-product-tile__variant{font:400 13px/1.3 "Source Sans 3","Source Sans Pro",sans-serif!important;color:#6B6E72!important;opacity:1!important;margin-top:3px!important}',
    '.upcart-internal-component-product-tile__product-pricing{grid-column:1/2!important;width:auto!important;margin-top:9px!important;display:flex!important;align-items:center!important;justify-content:flex-start!important;flex-direction:row!important;flex-wrap:nowrap!important;gap:0;text-align:left!important;overflow:hidden}',
    '.upcart-internal-component-product-tile__price-group{display:inline-flex!important;align-items:center;gap:0;flex:none!important;margin-right:6px}',
    '.upcart-internal-component-product-tile__product-pricing .upcart-internal__visually-hidden{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;margin:0!important}',
    '.upcart-internal-component-product-tile__price-compare-at{margin-right:5px!important}',
    '.upcart-internal-component-product-tile__controls{grid-column:2/3!important;width:auto!important;margin:9px 0 0 8px!important}',
    '.upcart-internal-component-product-tile,ul.upcart-internal-cart-items,[class*="CartPreview__bottomModules"]{border:0!important}',
    '.upcart-internal-component-product-tile__price-compare-at{font:400 13.5px/1 "Source Sans 3","Source Sans Pro",sans-serif!important;color:#8D9094!important}',
    '.upcart-internal-component-product-tile__price{font:600 15px/1 "Source Sans 3","Source Sans Pro",sans-serif!important;color:#1F2024!important}',
    '#CartPopup .cc-badge{font:700 10.5px/1 Montserrat,sans-serif!important;letter-spacing:.6px;padding:4px 6px!important;border-radius:2px;margin-left:0!important;white-space:nowrap}',
    '.upcart-internal-component-product-tile__quantity-selector{height:28px!important;border-radius:4px!important}',
    '.upcart-internal-component-product-tile__quantity-minus,.upcart-internal-component-product-tile__quantity-plus{width:26px!important;min-width:26px!important;height:28px!important;padding:0!important}',
    '.upcart-internal-component-product-tile__quantity-selector input{width:30px!important;min-width:30px!important;height:28px!important;font-size:14px!important;padding:0!important}',
    '.upcart-public-product-properties__subscription{display:none!important}',
    '.upcart-internal-component-product-tile__subscription-upgrade{display:none!important}',
    '.cc2-chip{display:inline-block;justify-self:start;margin-top:8px;background:#E8F4EC;color:#2E7D4F;font:600 12px/1 "Source Sans 3","Source Sans Pro",sans-serif;letter-spacing:.2px;padding:5px 8px;border-radius:3px}',
    /* switch box */
    '.cc2-switch{background:#F7FBFB;border:1px solid #DCEFF2;border-radius:4px;padding:18px 16px 16px;position:relative;margin:-4px 0 18px;text-align:center}',
    '.cc2-switch .cc2-tag{position:absolute;top:-9px;left:50%;transform:translateX(-50%);background:#FBC84D;color:#494949;font:600 10.5px/1 Montserrat,sans-serif;letter-spacing:.4px;padding:4px 8px;border-radius:2px;white-space:nowrap}',
    '.cc2-switch h4{margin:0;font:600 15px/1.3 Montserrat,sans-serif;letter-spacing:.2px;color:#1F2024}',
    '.cc2-switch p{margin:6px 0 0;font:400 13px/1.4 "Source Sans 3","Source Sans Pro",sans-serif;color:#494949}',
    '.cc2-btn-f{display:block;width:100%;margin-top:12px;background:#006972;color:#fff;border:0;text-align:center;font:700 14px/1 "Source Sans 3","Source Sans Pro",sans-serif;letter-spacing:.3px;padding:12px 0;border-radius:4px;cursor:pointer}',
    /* product row */
    '.cc2-prow{border-top:1px solid #ECE9E4;margin:4px 20px 0;padding:18px 0 16px}',
    '.cc2-prow h4{margin:0 0 12px;font:600 13px/1 Montserrat,sans-serif;letter-spacing:.3px;color:#1F2024}',
    '.cc2-prow ~ * .upcart-internal-upsell{display:none!important}',
    '.cc2-cards{display:flex;gap:12px;overflow-x:auto;margin-right:-20px;padding-right:20px;scroll-snap-type:x proximity;scrollbar-width:none;-webkit-overflow-scrolling:touch}',
    '.cc2-cards::-webkit-scrollbar{display:none}',
    '.cc2-card{flex:none;width:150px;border:1px solid #ECE9E4;border-radius:4px;padding:0 0 12px;display:flex;flex-direction:column;background:#fff;scroll-snap-align:start}',
    '.cc2-card .cc2-im{height:96px;background:#F6F4F0;border-radius:4px 4px 0 0;overflow:hidden;display:flex;align-items:center;justify-content:center}',
    '.cc2-card .cc2-im.w{background:#fff}',
    '.cc2-card .cc2-im img{width:100%;height:100%;object-fit:contain}',
    '.cc2-card .cc2-im.w img{padding:4px 0}',
    '.cc2-ct{padding:10px 10px 0;display:flex;flex-direction:column;flex:1}',
    '.cc2-ct h5{margin:0;font:600 13px/1.25 Montserrat,sans-serif;letter-spacing:.15px;color:#1F2024}',
    '.cc2-why{font:400 11.5px/1.3 "Source Sans 3","Source Sans Pro",sans-serif;color:#6B6E72;margin-top:4px}',
    '.cc2-stars{display:flex;align-items:center;gap:4px;margin-top:4px;font:400 11.5px/1 "Source Sans 3","Source Sans Pro",sans-serif;color:#6B6E72}',
    '.cc2-stars .st{color:#FBC84D;font-size:11.5px}',
    '.cc2-cp{margin-top:6px;font:400 12.5px/1.3 "Source Sans 3","Source Sans Pro",sans-serif;color:#1F2024}',
    '.cc2-cp s{color:#8D9094;margin-right:3px}',
    '.cc2-cp b{font-weight:600}',
    '.cc2-ot{font:400 11.5px/1.3 "Source Sans 3","Source Sans Pro",sans-serif;color:#6B6E72;margin-top:1px}',
    '.cc2-sp{flex:1;min-height:10px}',
    '.cc2-add{display:block;width:100%;border:1.5px solid #006972;color:#006972;background:#fff;border-radius:4px;font:700 12.5px/1 "Source Sans 3","Source Sans Pro",sans-serif;letter-spacing:.3px;padding:8px 0;text-align:center;cursor:pointer}',
    '.cc2-add[disabled],.cc2-btn-f[disabled]{opacity:.6;cursor:default}',
    /* quote, footer */
    '.cc2-quote{margin-top:auto!important;padding:2px 24px 12px;text-align:center;font:italic 400 12.5px/1.4 "Source Sans 3","Source Sans Pro",sans-serif;color:#6B6E72}',
    '.cc2-quote .qs{display:block;font-style:normal;color:#FBC84D;letter-spacing:1px;font-size:11px;margin-bottom:3px}',
    '.cc2-quote .qn{font-style:normal;color:#8D9094;white-space:nowrap}',
    '.cc2-trust{margin:0;padding-top:12px;text-align:center;font:400 12px/1.3 "Source Sans 3","Source Sans Pro",sans-serif;color:#6B6E72;white-space:nowrap}',
    '.cc2-trust .y{color:#FBC84D}',
    '.upcart-continue-shopping{margin-top:8px!important;padding:0!important}',
    '.upcart-continue-shopping a{font:400 14px/1.2 "Source Sans 3","Source Sans Pro",sans-serif!important;color:#1F2024}'
  ].join('\n');

  function m2(c) { return '$' + (c / 100).toFixed(2); }
  function m0(c) { return c % 100 ? m2(c) : '$' + (c / 100); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- data ---------- */
  var cart = null, fetching = false, products = {};
  function loadCart(cb) {
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; fetching = false; cb(); })
      .catch(function () { fetching = false; });
  }
  // Product prices, images and plan prices, once per browser session (5 GETs, cached in sessionStorage).
  var productsLoading = false;
  function loadProducts(cb) {
    try { var c = JSON.parse(sessionStorage.getItem('cc-cart2-products') || 'null'); if (c && c.t > Date.now() - 36e5) { products = c.p; return; } } catch (e) {}
    if (productsLoading) return;
    productsLoading = true;
    var keys = Object.keys(HANDLES);
    Promise.all(keys.map(function (k) {
      return fetch('/products/' + HANDLES[k] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var p = {};
      list.forEach(function (prod, i) { if (prod) p[keys[i]] = slim(prod); });
      products = p;
      productsLoading = false;
      try { sessionStorage.setItem('cc-cart2-products', JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
      cb();
    });
  }
  function slim(prod) {
    return {
      id: prod.id, img: prod.featured_image,
      variants: prod.variants.map(function (v) {
        return { id: v.id, title: v.title, price: v.price, available: v.available, img: v.featured_image && v.featured_image.src,
          plans: (v.selling_plan_allocations || []).map(function (a) { return { id: a.selling_plan_id, price: a.price, compare: a.compare_at_price }; }) };
      })
    };
  }
  function variant(key, id) {
    var p = products[key]; if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
    return null;
  }
  function planOf(v, planId) {
    if (!v) return null;
    for (var i = 0; i < v.plans.length; i++) if (v.plans[i].id === planId) return v.plans[i];
    return null;
  }

  /* ---------- cart rules ---------- */
  function isDonation(it) { return it.sku === DONATE_SKU || (it.url && it.url.indexOf(DONATE) === 0); }
  function isGift(it) { return !!(it.properties && it.properties._hs_gift); }
  function isPaid(it) { return !isDonation(it) && !isGift(it) && it.final_line_price > 0; }
  function isSub(it) { return !!it.selling_plan_allocation; }
  function itemKey(it) { return it.variant_id + ':' + (it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.id : ''); }
  function hasOtherCodes() {
    // Any discount code other than the free donation code can change what a switch costs: hide the box then.
    return (cart.discount_codes || []).some(function (d) { return !/donat|patriots|paws/i.test(d.code); });
  }
  // The switch box: a one-time 1 Pack laundry line at $25, quantity 1, no line discount, not a gift.
  function switchOffer(it) {
    if (it.handle !== LAUNDRY || isSub(it) || isGift(it) || it.quantity !== 1) return null;
    if (!/(^|\/\s*)1 Pack$/.test(it.variant_title || '')) return null;
    if ((it.line_level_discount_allocations || []).length || it.final_line_price !== it.original_line_price) return null;
    if (hasOtherCodes()) return null;
    var one = it.original_price;
    var plan = planOf(variant('laundry', it.variant_id), PLAN.laundry);
    if (!plan || one !== 2500 || plan.price >= one) return null;
    return { one: one, plan: plan.price, save: one - plan.price };
  }

  /* ---------- actions (only on a shopper tap) ---------- */
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function refresh() {
    try { if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
  }
  function busy(btn, label) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = label; }
  function unbusy(btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || btn.textContent; }
  function doSwitch(btn, key) {
    var it = (cart.items || []).filter(function (i) { return i.key === key; })[0];
    if (!it) return;
    var props = {};
    Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
    props._hs_cartoffer = 'switch';
    busy(btn, 'Switching');
    post('/cart/change.js', { id: key, quantity: it.quantity, selling_plan: PLAN.laundry, properties: props })
      .then(function () { refresh(); })
      .catch(function () { unbusy(btn); });
  }
  function doAdd(btn, id, plan) {
    var item = { id: id, quantity: 1, properties: { _hs_cartoffer: plan ? 'addon' : 'addon_onetime' } };
    if (plan) item.selling_plan = plan;
    busy(btn, 'Adding');
    post('/cart/add.js', { items: [item] })
      .then(function () { refresh(); })
      .catch(function () { unbusy(btn); });
  }

  /* ---------- rendering (idempotent: an element is only replaced when its content changes) ---------- */
  function put(parent, before, cls, html, sig, bind) {
    // Keep one element with class cls under parent, before `before` (null = append). Replace only when sig changes.
    var el = null;
    for (var c = parent.firstChild; c; c = c.nextSibling) if (c.nodeType === 1 && c.classList.contains(cls)) { el = c; break; }
    if (html === null) { if (el) el.remove(); return null; }
    if (el && el.getAttribute('data-sig') === sig && (before === undefined || el.nextSibling === before)) return el;
    if (el) el.remove();
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    el = tmp.firstChild;
    el.setAttribute('data-sig', sig);
    if (before === undefined) parent.appendChild(el); else parent.insertBefore(el, before);
    if (bind) bind(el);
    return el;
  }

  function lineKeyOf(li) {
    var a = li.querySelector('a[href*="variant="]');
    if (!a) return null;
    var u = new URL(a.getAttribute('href'), location.origin);
    return u.searchParams.get('variant') + ':' + (u.searchParams.get('selling_plan') || '');
  }

  function cards(subCart) {
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    var laundry = (cart.items || []).filter(function (it) { return it.handle === LAUNDRY && !isGift(it); })[0];
    var ff = laundry && /fragrance free/i.test(laundry.variant_title || '');
    var defs = [
      { k: 'dryer', id: ff ? V.dryerFF : V.dryerOB, plan: PLAN.dryer, name: 'Dryer Sheets', why: 'Most added with laundry sheets', stars: '4.8 (156)', vimg: true },
      { k: 'dish', id: V.dish, plan: PLAN.dish, name: 'Dishwasher Detergent Sheets', stars: '4.5 (271)' },
      { k: 'wool', id: V.wool, name: 'Wool Dryer Balls', white: true },
      { k: 'towels', id: V.towels, name: 'Reusable Paper Towels', white: true }
    ];
    var out = [];
    defs.forEach(function (d) {
      var p = products[d.k], v = variant(d.k, d.id);
      if (!p || !v || !v.available || inCart[p.id]) return;
      var pl = subCart && d.plan ? planOf(v, d.plan) : null;
      var price = pl
        ? (pl.compare && pl.compare > pl.price ? '<s>' + m0(pl.compare) + '</s>' : '') + '<b>' + m0(pl.price) + '</b> every 30 days'
        : '<b>' + m2(v.price) + '</b>';
      out.push('<div class="cc2-card"><div class="cc2-im' + (d.white ? ' w' : '') + '"><img alt="" loading="lazy" src="' + esc(img(d.vimg && v.img ? v.img : p.img, 300)) + '"></div><div class="cc2-ct">' +
        '<h5>' + d.name + '</h5>' + (d.why ? '<div class="cc2-why">' + d.why + '</div>' : '') +
        (d.stars ? '<div class="cc2-stars"><span class="st">★</span> ' + d.stars + '</div>' : '') +
        '<div class="cc2-cp">' + price + '</div>' + (pl ? '' : '<div class="cc2-ot">One-time</div>') +
        '<div class="cc2-sp"></div><button type="button" class="cc2-add" data-id="' + v.id + '" data-plan="' + (pl ? d.plan : '') + '">' + (pl ? 'Add to plan' : 'Add') + '</button></div></div>');
    });
    return out.join('');
  }

  function render(root) {
    if (!cart) return;
    var popup = root.querySelector('#CartPopup');
    if (!popup) return;
    if (!root.getElementById('cc2-style')) {
      var st = document.createElement('style');
      st.id = 'cc2-style';
      st.textContent = CSS;
      root.appendChild(st);
    }
    var items = cart.items || [];
    var paid = items.reduce(function (n, it) { return n + (isPaid(it) ? it.quantity : 0); }, 0);
    var subCart = items.some(function (it) { return isSub(it) && !isGift(it); });
    var hasLaundry = items.some(function (it) { return it.handle === LAUNDRY && !isGift(it); });

    // 1. Tracked delivery bar under the header.
    var head = root.querySelector('.upcart-internal-header');
    if (head) {
      var full = paid >= 2;
      var shipHtml = paid < 1 ? null : '<div class="cc2-ship"><div class="cc2-ship-t">' + (full ? TICK : TRUCK) + '<span>' +
        (full ? 'Your order ships with tracked priority delivery' : 'Add 1 more item and your order ships with tracked priority delivery') +
        '</span></div><div class="cc2-track"><i style="width:' + (full ? 100 : 50) + '%"></i></div></div>';
      put(head.parentNode, undefined, 'cc2-ship', shipHtml, 'ship' + (full ? 2 : paid));
    }

    // 2. Lines: map each <li> to its cart item (same variant and plan, in order).
    var lis = Array.prototype.slice.call(root.querySelectorAll('li.upcart-internal-cart-item'));
    var used = {};
    var rows = lis.map(function (li) {
      var k = lineKeyOf(li), it = null;
      for (var i = 0; i < items.length; i++) if (!used[i] && itemKey(items[i]) === k) { it = items[i]; used[i] = true; break; }
      return { li: li, it: it };
    });
    // Groups: selling-plan lines by cadence, then one-time lines. The free donation line is hidden by cc-clean-cart.
    var groups = [], byLabel = {};
    rows.forEach(function (r) {
      if (!r.it || (isDonation(r.it) && r.it.final_line_price === 0)) return;
      var spa = r.it.selling_plan_allocation, label;
      if (spa) {
        var m = /Every\s+(\d+)\s+Days?/i.exec(spa.selling_plan.name || '');
        label = m ? 'Delivered every ' + m[1] + ' days · Skip or cancel anytime' : 'Delivered on your plan · Skip or cancel anytime';
      } else label = 'One-time purchase';
      if (!(label in byLabel)) { byLabel[label] = groups.length; groups.push({ label: label, sub: !!spa, rows: [] }); }
      groups[byLabel[label]].rows.push(r);
    });
    groups.sort(function (a, b) { return (b.sub ? 1 : 0) - (a.sub ? 1 : 0); });
    // Within a group: laundry first, then the other lines in the order they were added (cart.items is newest first).
    groups.forEach(function (g) {
      g.rows.sort(function (a, b) {
        var la = a.it.handle === LAUNDRY && !isGift(a.it) ? 0 : 1, lb = b.it.handle === LAUNDRY && !isGift(b.it) ? 0 : 1;
        return la - lb || items.indexOf(b.it) - items.indexOf(a.it);
      });
    });
    var seen = [];
    groups.forEach(function (g, gi) {
      g.rows.forEach(function (r, ri) {
        seen.push(r.li);
        var ord = String(gi * 100 + ri + 1);
        if (r.li.style.order !== ord) r.li.style.order = ord;
        r.li.classList.toggle('cc2-sep', ri > 0);
        put(r.li, r.li.firstChild && r.li.firstChild.classList && r.li.firstChild.classList.contains('cc2-grp') ? r.li.firstChild.nextSibling : r.li.firstChild,
          'cc2-grp', ri === 0 ? '<div class="cc2-grp"><span>' + esc(g.label) + '</span></div>' : null, g.label);
        decorate(r.li, r.it);
      });
    });
    rows.forEach(function (r) {
      if (seen.indexOf(r.li) > -1) return;
      r.li.classList.remove('cc2-sep');
      put(r.li, undefined, 'cc2-grp', null);
      put(r.li, undefined, 'cc2-switch', null);
      if (r.li.style.order !== '9999') r.li.style.order = '9999';
    });

    // 3. "Add to your order" product row, in place of UpCart's own upsells (laundry carts only).
    var ul = root.querySelector('ul.upcart-internal-cart-items');
    var body = root.querySelector('.upcart-cart-body');
    if (ul && body) {
      var cardHtml = hasLaundry && Object.keys(products).length ? cards(subCart) : '';
      put(ul.parentNode, ul.nextSibling && ul.nextSibling.classList && ul.nextSibling.classList.contains('cc2-prow') ? ul.nextSibling.nextSibling : ul.nextSibling,
        'cc2-prow', cardHtml ? '<div class="cc2-prow"><h4>Add to your order</h4><div class="cc2-cards">' + cardHtml + '</div></div>' : null, cardHtml,
        function (el) {
          el.querySelectorAll('.cc2-add').forEach(function (b) {
            b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (!b.disabled) doAdd(b, Number(b.getAttribute('data-id')), Number(b.getAttribute('data-plan')) || null); });
          });
        });
      // 4. Judy's quote at the bottom of the scroll area (sits just above the footer when there is room).
      var qEl = put(body, undefined, 'cc2-quote', items.length && hasLaundry ? '<div class="cc2-quote"><span class="qs">★★★★★</span>“' + QUOTE + '” <span class="qn">Judy</span></div>' : null, 'q');
      // Show the quote only when the whole drawer fits without scrolling; otherwise it would sit half under the footer.
      if (qEl) { qEl.style.display = ''; if (body.scrollHeight > body.clientHeight + 1) qEl.style.display = 'none'; }
    }

    // 5. Trust line under Checkout, above "Or continue shopping".
    var more = root.querySelector('.upcart-continue-shopping');
    var btn = root.querySelector('[class*="Footer__checkoutButton"]');
    if (more && btn && items.length) {
      put(more.parentNode, more, 'cc2-trust', '<p class="cc2-trust"><span class="y">★</span> 4.7 from 5.5k ratings · Money-back guarantee on your first order</p>', 't');
    } else if (more) put(more.parentNode, undefined, 'cc2-trust', null);
  }

  function decorate(li, it) {
    // "60 sheets" on laundry lines (60 per pack), on the simple cart's "Scent · N Pack" text.
    if (it.handle === LAUNDRY) {
      var cv = li.querySelector('.cc-variant');
      var pm = /(\d+)\s*Pack/i.exec(it.variant_title || '');
      if (cv && pm && !/sheets$/.test(cv.textContent)) cv.textContent = cv.textContent + ' · ' + (60 * Number(pm[1])) + ' sheets';
    }
    // After a switch: green chip on that line.
    var info = li.querySelector('.upcart-internal-component-product-tile__info');
    var spa = it.selling_plan_allocation;
    var chip = null;
    if (info && spa && it.properties && it.properties._hs_cartoffer === 'switch' && spa.compare_at_price > spa.price) {
      chip = '<span class="cc2-chip">Saving ' + m0((spa.compare_at_price - spa.price) * it.quantity) + ' a month</span>';
    }
    if (info) put(info, undefined, 'cc2-chip', chip, chip || '');
    // Switch box under a one-time 1 Pack laundry line.
    var o = switchOffer(it);
    var html = o ? '<div class="cc2-switch"><span class="cc2-tag">Most customers subscribe</span><h4>Save ' + m0(o.save) + ': switch to monthly</h4>' +
      '<p>' + m0(o.plan) + ' instead of ' + m0(o.one) + ', then ' + m0(o.plan) + ' every 30 days.<br>Skip or cancel anytime.</p>' +
      '<button type="button" class="cc2-btn-f">Switch to monthly</button></div>' : null;
    put(li, undefined, 'cc2-switch', html, (html || '') + it.key, function (el) {
      var b = el.querySelector('.cc2-btn-f');
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (!b.disabled) doSwitch(b, it.key); });
    });
  }

  /* ---------- observer (same pattern as cc-clean-cart.js) ---------- */
  function ours(n) {
    // true when a mutation only touched our own or cc-clean-cart's nodes
    for (; n; n = n.parentNode) {
      if (n.nodeType === 1 && n.className && typeof n.className === 'string' && /(^|\s)(cc2?-[\w-]+)/.test(n.className) && !/upcart/.test(n.className)) return true;
      if (n.nodeType === 11) return false;
    }
    return false;
  }
  function onlyOurs(recs) {
    for (var i = 0; i < recs.length; i++) {
      var r = recs[i], nodes = [].slice.call(r.addedNodes).concat([].slice.call(r.removedNodes));
      if (r.type === 'characterData') { if (!ours(r.target.parentNode)) return false; continue; }
      if (!nodes.length) continue;
      for (var j = 0; j < nodes.length; j++) if (!ours(nodes[j]) && !(nodes[j].nodeType === 1 && nodes[j].id === 'cc-style')) {
        // a text change inside cc-clean-cart's variant div counts as ours
        if (nodes[j].nodeType === 3 && ours(r.target)) continue;
        return false;
      }
    }
    return true;
  }

  var observed = null, mo = null, timer = 0, needFetch = true;
  function schedule(root) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!isOn()) return;
      loadProducts(function () { needFetch = true; schedule(root); });
      var run = function () {
        mo.disconnect();
        try { render(root); } catch (e) { /* never break the cart */ }
        mo.takeRecords();
        mo.observe(root, { childList: true, subtree: true, characterData: true });
      };
      run();
      if (needFetch || !cart) { needFetch = false; loadCart(run); }
    }, 90);
  }

  function attach() {
    var host = document.getElementById('upCart');
    var root = host && host.shadowRoot;
    if (!root || observed === root) return;
    observed = root;
    mo = new MutationObserver(function (recs) {
      if (!onlyOurs(recs)) needFetch = true; // UpCart re-rendered: read the cart once more
      schedule(root);
    });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
    schedule(root);
  }

  override();
  var tries = 0;
  var iv = setInterval(function () { attach(); if (observed || ++tries > 120) clearInterval(iv); }, 500);
})();
